module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('div', [_vm._m(0), _vm._v(" "), _c('el-table', {
    staticStyle: {
      "width": "100%"
    },
    attrs: {
      "data": _vm.vmpDataList,
      "show-header": false
    }
  }, [_c('el-table-column', {
    staticStyle: {
      "padding": "5px 2px"
    },
    attrs: {
      "prop": "label",
      "label": "Field"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "value",
      "label": "Value"
    }
  })], 1)], 1), _vm._v(" "), _c('div', {
    staticClass: "flex margin-t-10",
    staticStyle: {
      "justify-content": "center",
      "margin-top": "30px"
    }
  }, [_c('el-button', {
    staticClass: "margin-b-20",
    on: {
      "click": function($event) {
        $event.preventDefault();
        return _vm.confirmSync($event)
      }
    }
  }, [_vm._v("\n      " + _vm._s(_vm.$t('button.syncData')) + "\n  ")])], 1)])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('h2', [_vm._v("Result from "), _c('u', [_c('b', [_vm._v("Vinmonopolet")])])])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-047fb8cd","hasScoped":false}!./src/app/components/vmpSyncConfirmPopup/vmpSyncConfirmPopup.html
// module id = 2894
// module chunks = 1